import { getIndexedPath } from 'owa-url';

export default function getServiceWorkerPath(rootVdirName: string, locationObj: Location): string {
    let indexedPath = rootVdirName;
    if (rootVdirName != null) {
        indexedPath = getIndexedPath('/' + rootVdirName, locationObj.pathname);
    }

    return indexedPath;
}
